// client/src/auth/authFetch.js
// Monkey-patches window.fetch once so every /api/* request automatically
// carries the current impersonation header. The AuthContext calls
// setImpersonationEmail(email | null) when an admin starts or stops
// impersonating someone.
//
// Non-API fetches (e.g. third-party CDNs, /.auth/*) are passed through
// unchanged.

const IMPERSONATE_HEADER = 'x-impersonate-email';

let currentImpersonation = null;
let installed = false;

export function installAuthFetch() {
  if (installed || typeof window === 'undefined' || !window.fetch) return;
  installed = true;

  const origFetch = window.fetch.bind(window);

  window.fetch = function patchedFetch(input, init = {}) {
    let url = '';
    try {
      url = typeof input === 'string' ? input : (input?.url || '');
    } catch { url = ''; }

    if (currentImpersonation && url && url.startsWith('/api/')) {
      const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
      headers.set(IMPERSONATE_HEADER, currentImpersonation);
      return origFetch(input, { ...init, headers });
    }
    return origFetch(input, init);
  };
}

export function setImpersonationEmail(email) {
  currentImpersonation = (email && String(email).toLowerCase().trim()) || null;
}

export function getImpersonationEmail() {
  return currentImpersonation;
}
